import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { Apollo, ApolloModule } from 'apollo-angular';
import { HttpLinkModule } from 'apollo-angular-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { ApolloLink, from } from 'apollo-link';
import { ErrorLink } from 'apollo-link-error';
import { HttpLink } from 'apollo-link-http';
import { take } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { AuthService } from '../shared/services/security/auth.service';
import { GraphqlErrorHandler } from '../shared/services/security/graphql-error-handler.service';
import { UserService } from '../shared/services/security/user.service';

@NgModule({
  imports: [
    CommonModule
  ],
  exports: [
    ApolloModule,
    HttpLinkModule
  ],
  declarations: []
})

export class GraphQlModule {

  httpLink = new HttpLink({
    uri: environment.graphQLPath,
    useGETForQueries: false
  });

  authMiddleware = new ApolloLink((operation, forward) => {
    operation.setContext({
      headers: {
        authorization: (this.authService.getToken()) ? `JWT ${this.authService.getToken()}` : null
      }
    });

    return forward(operation);
  });

  constructor(
    apollo: Apollo,
    public authService: AuthService,
    private graphqlErrorHandler: GraphqlErrorHandler,
    protected readonly userService: UserService,
  ) {
    const errorLink = new ErrorLink(({ graphQLErrors, networkError }) => {
      if (graphQLErrors) {
        this.graphqlErrorHandler.handle(graphQLErrors);
      }
    });

    const afterLink = new ApolloLink((operation, forward) => {

      return forward(operation).map(response => {
        const RefreshUserInResponse = (operation.getContext().response as Response).headers.get('X-RefreshUser');

        if (RefreshUserInResponse === '1') {
          this.userService.userLogged$().pipe(take(1)).subscribe(
            async succ => {
              if (succ.data && succ.data.loggedUser) {
                this.authService.setUser(succ.data.loggedUser);
                await this.authService.refreshToken(succ.data.loggedUser.email).toPromise();
                this.authService.refreshViewWithNewUser();
              }
            });
        }
        return response;
      });
    });

    apollo.create({
      link: from([errorLink, afterLink, this.authMiddleware, this.httpLink]),
      cache: new InMemoryCache(),
      defaultOptions: {
        watchQuery: {
          fetchPolicy: 'no-cache',
          errorPolicy: 'ignore'
        },
        query: {
          fetchPolicy: 'no-cache',
          errorPolicy: 'all'
        }

      }
    });
  }
}
